module.exports = __webpack_public_path__ + "static/media/BR 5.cbd90148.mp3";